// extracted by mini-css-extract-plugin
module.exports = {"container":"FetchingPanel_container__sxABW","spinner":"FetchingPanel_spinner__GAyyh","inline":"FetchingPanel_inline__k2aZY"};